import Registration from "../../../../jsx/pages/Customer/Registration";

const LoginWrapper = function (props) {
  return <Registration />;
};

export default constore(LoginWrapper);
